<template lang="pug">
.v-promo-slider.promo-slider(v-if="data" :key="isTablet" :class="uniqueId" :id="data?.id")
	v-base-slider(:options="options" theme="dark")
		v-swiper-slide.swiper-slide(v-for="slide in data.items" :class="[data.items?.length === 1 ? 'swiper-slide--only': '']")
			.promo-slider__slide(:style="{backgroundImage: `url('${slide.backgroundImage}')`, backgroundColor: slide.backgroundColor}")
				.promo-slider__slide-content
					.promo-slider__slide-title(v-if="slide.title") {{slide.title}}
					.promo-slider__slide-text(v-if="slide.text") {{slide.text}}
					.promo-slider__slide-actions(v-if="slide.actions")
						a.promo-slider__slide-action.btn(v-for="action in slide.actions" :href="action.link" :class="action.className") {{action.text}}
				.promo-slider__slide-banner(v-if="slide.image")
					img.promo-slider__slide-banner-img(:src="slide.image.src" :alt="slide.image.alt")
</template>

<script>

import sourceMixin from "components/mixins/v-mixin-source.vue";
import breakpoints from "../scripts/breakpoints.js";
import {SwiperSlide} from 'swiper/vue';
import isMobMixin from "./mixins/v-mixin-is-mob.vue";
import uniqueId from "scripts/helpers/uniqueId.js";

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],

	components: {
		'v-swiper-slide': SwiperSlide
	},

	data() {
		return {
			data: null,
			uniqueId: uniqueId('swiper-'),
		}
	},

	computed: {
		options() {
			return {
				watchOverflow: true,
				slidesPerView: 1,
				spaceBetween: 11,
				resizeObserver: true,
				loop: this.data.items?.length > 1,
				pagination: this.isTablet ? false : {
					clickable: true,
					el: `.${this.uniqueId} .swiper-pagination`,
					dynamicBullets: false
				},
				navigation: {
					prevEl: '.swiper-button-prev',
					nextEl: '.swiper-button-next'
				},
				breakpoints: {
					[breakpoints['tablet']]: {
						pagination: false,
						slidesPerView: 1,
						spaceBetween: 27
					}
				}
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>